import React, { Component } from "react";
import { registerForLocalization, provideLocalizationService } from "@progress/kendo-react-intl";
import NahlasenieDodavky from "./NahlasenieDodavky/NahlasenieDodavky.js";
import LoadingPanel from "../common/LoadingPanel";
import NahlasenieBaliky from "./NahlasenieDodavky/NahlasenieBaliky";
import NahlasenieRozdiely from "./NahlasenieDodavky/NahlasenieRozdiely";
import { Button } from "@progress/kendo-react-buttons";
import { Localization } from "../common/Localization";
import DialogWindow from "../common/DialogWindow.js";
import DetailDodavkyDialogContent from "./DetailDodavkyDialogContent.js";
import { nahlasenieDodavkyController } from "../../controllers/nahlaseniedodavky.controller.js";
import { MessageTypeEnum, ButtonGroupEnum, ButtonMessageEnum } from "../../enums/index.js";
import confirmService from "../common/confirmService/index.js";
import NahlasenieEditaciaDialogContent from "./RucniNahlasenieDodavky/NahlasenieEditaciaDialogContent.js";
import NahlasenieKusyDialogContent from "./RucniNahlasenieDodavky/NahlasenieKusyDialogContent.js";
import Moment from "moment";

class NahlasenieDodavkyDialogContent extends Component {
    state = {
        selectedNahlasenie: this.props.selectedNahlasenieId,
        selectedIdDodavka: null,
        selectedNahlasenieDetail: null,
        dialog: {
            title: null,
            content: null,
            width: null,
            height: null
        }
    };

    changeSelectedNahlasenie = (nahlasenieId, iddodavka, nahlasenieDetail) => {
        this.setState({
            selectedNahlasenie: nahlasenieId,
            selectedIdDodavka: iddodavka,
            selectedNahlasenieDetail: nahlasenieDetail
        });
    };

    changeTitle = (title) => {
        var dialogProperty = { ...this.state.dialog };
        dialogProperty.title = title;
        this.setState({ dialog: dialogProperty });
    };

    openDetailDodavky = (iddodavka) => {
        var localizationService = provideLocalizationService(this);
        this.setState({
            dialog: {
                title: localizationService.toLanguageString("NahlasenieNenahlaseneDodavky.Grid.Dodávka", "Dodávka"),
                content: () => <DetailDodavkyDialogContent selectedDodavkaId={iddodavka} changeTitle={this.changeTitle} />,
                height: "90%",
                width: "90%"
            }
        });
    };

    handleClickNahlasenie = () => {
        this.openDetailDodavky(this.state.selectedIdDodavka);
    };

    handleClickDoprijem = async () => {
        var localizationService = provideLocalizationService(this);

        if (!this.state.selectedIdDodavka) {
            await confirmService.show({
                type: MessageTypeEnum.EXCLAMATION,
                message: localizationService.toLanguageString("NahFRM.Vyberte nahlásenie zo zoznamu !", "Vyberte nahlásenie zo zoznamu !")
            });
            return;
        }

        nahlasenieDodavkyController.doprijemBalikov(this.state.selectedIdDodavka).then(async (response) => {
            if (response.isError) {
                await confirmService.show({
                    type: MessageTypeEnum.EXCLAMATION,
                    message: response.errorMessage
                });
                return;
            }

            const confirmResult = await confirmService.show({
                type: MessageTypeEnum.QUESTION,
                message: response.errorMessage,
                buttons: ButtonGroupEnum.OK_CANCEL
            });

            if (confirmResult == ButtonMessageEnum.OK) {
                nahlasenieDodavkyController.doprijemBalikovOtvoreni(response).then(async (response) => {
                    if (response.isError) {
                        await confirmService.show({
                            type: MessageTypeEnum.EXCLAMATION,
                            message: response.errorMessage
                        });
                    } else {
                        this.props.reloadNahlasenieGrids();
                        await confirmService.show({
                            type: MessageTypeEnum.INFORMATIVE,
                            message: response.errorMessage
                        });
                    }
                });
            }
        });
    };

    handleDetailNahlasenie = () => {
        var nahlasenie = this.state.selectedNahlasenieDetail;
        var localizationService = provideLocalizationService(this);

        if (nahlasenie.skladFrom === 91 || (nahlasenie.skladFrom === 1 && nahlasenie.cisloDodavky >= 20000 && nahlasenie.cisloDodavky <= 39999)) {
            nahlasenieDodavkyController
                .nahlaseniDodavkyDachser(nahlasenie.idexpedicia, nahlasenie.cisloDodavky, nahlasenie.skladFrom)
                .then(async (response) => {
                    this.setState({
                        nahlasitDodavkuDisabled: false
                    });

                    if (response.isError) {
                        await confirmService.show({
                            type: MessageTypeEnum.EXCLAMATION,
                            message: response.errorMessage,
                            logMessage: true
                        });
                        return;
                    }
                    this.openDialogNahlaseniKusy(response);
                });
        } else {
            nahlasenieDodavkyController
                .getDetailNahlasenie(nahlasenie.idexpedicia, nahlasenie.cisloDodavky, nahlasenie.skladFrom, nahlasenie.idnahlasenie)
                .then(async (response) => {
                    if (response.isError) {
                        await confirmService.show({
                            type: MessageTypeEnum.EXCLAMATION,
                            message: response.errorMessage,
                            logMessage: true
                        });
                        return;
                    }
                    var title = localizationService
                        .toLanguageString(
                            "RucniNahl.Nenahlášené dodávky č. <P1>, odesílatel <P2> ze dne <P3>",
                            "Nenahlášené dodávky č. <P1>, odesílatel <P2> ze dne <P3>"
                        )
                        .replace("<P1>", response.cisloDodavky || "")
                        .replace("<P2>", response.odosielatel || "")
                        .replace("<P3>", Moment(response.datumNahlasenia).format("D.M.YYYY") || "");
                    this.setState({
                        dialog: {
                            title: title,
                            content: (onClose) => <NahlasenieEditaciaDialogContent toggleDialog={onClose} nahlasenie={response} />,
                            height: "600px",
                            width: "1000px"
                        }
                    });
                });
        }
    };

    openDialogNahlaseniKusy(dodavka) {
        var localizationService = provideLocalizationService(this);
        var title = localizationService
            .toLanguageString("RucniNahl.Nenahlášené dodávky č. <P1>, odesílatel <P2> ze dne <P3>", "Nenahlášené dodávky č. <P1>, odesílatel <P2> ze dne <P3>")
            .replace("<P1>", dodavka.cisloDodavky || "")
            .replace("<P2>", dodavka.odosilatel || "")
            .replace("<P3>", Moment(dodavka.datumExpedicie).format("D.M.YYYY") || "");
        this.setState({
            dialog: {
                title: title,
                hasClosingConfirmDialog: true,
                content: (onClose) => (
                    <NahlasenieKusyDialogContent
                        toggleDialog={onClose}
                        dodavka={dodavka}
                        reloadSpravyGrid={this.props.reloadSpravyGrid}
                        reloadNahlasNenahlasDodavkyGrid={this.props.reloadNahlasNenahlasDodavkyGrid}
                        readOnly={true}
                    />
                ),
                height: "600px",
                width: "1000px"
            }
        });
    }

    renderDialogContent() {
        return (
            <div id="NahlasenieDodavkyDialog">
                <div>
                    <div className="col-lg-8">
                        <NahlasenieDodavky
                            changeSelectedNahlasenie={this.changeSelectedNahlasenie}
                            defaultSelectedNahlasenie={this.state.selectedNahlasenie}
                            openDetailDodavky={this.openDetailDodavky}
                        />
                    </div>
                    <div className="col-lg-4">
                        <NahlasenieBaliky idNahlasenie={this.state.selectedNahlasenie} />
                        <NahlasenieRozdiely idNahlasenie={this.state.selectedNahlasenie} />
                    </div>
                </div>
                <div>
                    <div className="col-sm-7 button-bar">
                        <Button onClick={this.handleDetailNahlasenie} disabled={!this.state.selectedNahlasenieDetail} className="auto-focus">
                            <Localization messageKey={"NahFRM.Detail nahlásenie"} defaultMessage={"Detail nahlásenie"} />
                        </Button>
                        {/* <Button disabled>
                            <Localization messageKey={"NahFRM.Vytlačiť dodací list"} defaultMessage={"Vytlačiť dodací list"} />
                        </Button> */}
                        <Button onClick={this.handleClickDoprijem}>
                            <Localization messageKey={"NahFRM.Dopríjem balíkov"} defaultMessage={"Dopríjem balíkov"} />
                        </Button>
                    </div>
                    <div className="col-sm-5 text-right">
                        <Button onClick={this.handleClickNahlasenie}>
                            <Localization messageKey={"NahFRM.Podrobnosti nahlásenia"} defaultMessage={"Podrobnosti nahlásenia"} />
                        </Button>
                    </div>
                </div>
                <DialogWindow dialog={this.state.dialog} />
            </div>
        );
    }

    render() {
        let contents = this.state.loading ? <LoadingPanel /> : this.renderDialogContent();

        return <div>{contents}</div>;
    }
}

export default NahlasenieDodavkyDialogContent;

registerForLocalization(NahlasenieDodavkyDialogContent);



// WEBPACK FOOTER //
// ./src/components/dialogs/NahlasenieDodavkyDialogContent.js